import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { getRocketById, getLaunchesByRocket } from '../services/dataService';
import { getRocketImage } from '../utils/imageUtils';

/**
 * Rocket Details Page Component
 */
const RocketDetails = () => {
  const { id } = useParams();
  const rocket = getRocketById(id);
  const launches = getLaunchesByRocket(id);

  if (!rocket) {
    return (
      <div className="container" style={{ paddingTop: '50px', textAlign: 'center' }}>
        <h2>Rocket not found</h2>
        <Link to="/rockets" className="btn btn-primary" style={{ marginTop: '20px' }}>Back to Rockets</Link>
      </div>
    );
  }

  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <Link to="/rockets" className="btn btn-secondary" style={{ marginBottom: '20px' }}>
        ← Back to Rockets
      </Link>

      <div className="card" style={{ marginBottom: '30px' }}>
        <img 
          src={getRocketImage(rocket.id, rocket.name)} 
          alt={rocket.name}
          style={{ 
            width: '100%', 
            maxWidth: '800px',
            height: '500px', 
            objectFit: 'cover', 
            borderRadius: '8px', 
            marginBottom: '20px',
            display: 'block',
            margin: '0 auto 20px'
          }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <h1 style={{ fontSize: '36px', color: 'var(--highlight-color)', marginBottom: '20px' }}>
          {rocket.name}
        </h1>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '20px' }}>
          <div>
            <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>General Information</h3>
            <p style={{ marginBottom: '10px' }}><strong>Type:</strong> {rocket.type}</p>
            <p style={{ marginBottom: '10px' }}><strong>Manufacturer:</strong> {rocket.manufacturer}</p>
            <p style={{ marginBottom: '10px' }}><strong>Status:</strong> {rocket.status}</p>
            <p style={{ marginBottom: '10px' }}><strong>First Launch:</strong> {rocket.firstLaunch}</p>
            <p style={{ marginBottom: '10px' }}><strong>Stages:</strong> {rocket.stages}</p>
          </div>

          <div>
            <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>Physical Specifications</h3>
            <p style={{ marginBottom: '10px' }}><strong>Height:</strong> {rocket.height}m</p>
            <p style={{ marginBottom: '10px' }}><strong>Diameter:</strong> {rocket.diameter}m</p>
            <p style={{ marginBottom: '10px' }}><strong>Mass:</strong> {rocket.mass.toLocaleString()}kg</p>
            <p style={{ marginBottom: '10px' }}><strong>Payload Capacity:</strong> {rocket.payloadCapacity.toLocaleString()}kg</p>
          </div>

          <div>
            <h3 style={{ marginBottom: '15px', color: 'var(--text-dark)' }}>Propulsion</h3>
            <p style={{ marginBottom: '10px' }}><strong>Fuel Type:</strong> {rocket.fuelType}</p>
          </div>
        </div>

        {rocket.agencyId && (
          <div style={{ marginTop: '20px' }}>
            <Link to={`/agencies/${rocket.agencyId}`} className="btn btn-secondary">
              View Manufacturer Agency
            </Link>
          </div>
        )}
      </div>

      {/* Associated Launches */}
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '28px', marginBottom: '20px' }}>📅 Associated Launches</h2>
        {launches.length > 0 ? (
          <div className="grid">
            {launches.map(launch => (
              <div key={launch.id} className="card">
                <h3 style={{ color: 'var(--highlight-color)', marginBottom: '10px' }}>
                  {launch.missionName}
                </h3>
                <p><strong>Date:</strong> {new Date(launch.launchDate).toLocaleString()}</p>
                <p><strong>Status:</strong> {launch.status}</p>
                <p><strong>Type:</strong> {launch.missionType}</p>
                <Link to={`/launches/${launch.id}`} className="btn btn-primary" style={{ marginTop: '15px', display: 'block', textAlign: 'center' }}>
                  View Launch
                </Link>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ color: 'var(--text-dark)' }}>No launches found for this rocket.</p>
        )}
      </section>
    </div>
  );
};

export default RocketDetails;
